export const Comment = {
	comments: [],
	comment: null,
	isActCommentAdding: false,
	isCommentAdding: false
};
